import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import OtpModal from 'modules/auth/components/OtpModal';
import * as action from '../action';
import * as c from '../constant';
import PasswordModal from '../modals/PasswordModal';
import Generate2fa from '../modals/Generate2fa';

import EditProfileModal from '../modals/EditProfileModal';
import SuccessModal from '../modals/SuccessModal';
import ChangePasswordModal from '../modals/ChangePasswordModal';
import OtpSourceModal from '../modals/OtpSourceModal';

function Profile({ profile, getProfile, generate2fa }) {
  const otpSource = _.get(profile, 'attributes.otp_source', '');
  const email = _.get(profile, 'attributes.email', '');
  const formattedSource = otpSource.replace(/_/g, ' ');
  const UpdateInfo = () => {
    getProfile();
  };
  const setModal = useContext(ModalContext);

  const status = localStorage.getItem('status');

  const handleSuccessModal = () => {
    // e.preventDefault();
    if (status === 'enabled') {
      setModal({
        isOpen: true,
        content: <SuccessModal UpdateInfo={UpdateInfo} />,
        title: null,
        modalSize: 'modal-md',
      });
    }
  };

  const onGenerate2FA = (e) => {
    e.preventDefault();

    generate2fa({}, (data) => {
      setModal({
        title: 'Two-Factor Authentication',
        isOpen: true,
        content: (
          <Generate2fa
            item={data}
            id={profile.id}
            handleSuccessModal={handleSuccessModal}
          />
        ),
        modalSize: 'modal-md',
      });
    });
  };

  const onDisabled2FA = (e) => {
    e.preventDefault();
    setModal({
      title: 'Disable 2fa',
      isOpen: true,
      content: <PasswordModal />,
      modalSize: 'modal-md',
    });
  };

  const handleEditProfile = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <EditProfileModal UpdateInfo={UpdateInfo} />,
      title: 'Edit Profile',
      modalSize: 'modal-md',
    });
  };

  const handleSuccessOtpSource = (userId) => {
    localStorage.setItem('email', email);
    localStorage.setItem('otpReceiver', userId);
    localStorage.setItem(
      'otpSource',
      otpSource === 'EMAIL_OTP' ? 'MOBILE_NUMBER_OTP' : 'EMAIL_OTP'
    );

    setModal({
      isOpen: true,
      content: <OtpModal />,
      modalSize: 'modal-md',
      hideHeader: true,
    });
  };

  const handleUpdateOtp = () => {
    setModal({
      isOpen: true,
      content: (
        <OtpSourceModal
          otpSource={otpSource}
          profile={profile}
          onSuccess={handleSuccessOtpSource}
        />
      ),
      modalSize: 'modal-md',
      hideHeader: true,
    });
  };

  useEffect(() => {
    UpdateInfo();
  }, []);

  const handleChangePassword = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ChangePasswordModal profile={profile} />,
      title: 'Change Password',
      modalSize: 'modal-md',
    });
  };
  return (
    <div className="module-inner">
      <div className="module-inner-title">Personal Information</div>
      <div className="generic-module-nav mb-3">
        <div className="container-fluid">
          <div className="row mt-4">
            <div className="col-12 px-4 d-flex mb-4">
              <button
                type="button"
                className="btn btn-black px-4 ml-auto"
                onClick={handleEditProfile}
              >
                Edit <i className="fas fa-edit" />
              </button>
              <button
                type="button"
                className="btn btn-black btn-sm ml-2"
                onClick={handleChangePassword}
              >
                Change Password
              </button>
            </div>
          </div>
          <div className="row-profile card-body card-user">
            <div className="photo">
              <img
                src={
                  _.isNil(_.get(profile, 'attributes.photo')) ||
                  _.get(profile, 'attributes.photo') === null
                    ? ImagePlaceholder
                    : _.get(profile, 'attributes.photo')
                }
                className="rounded-circle avatar-thumbnail"
                alt="Name"
              />
            </div>
            <div className="mt-4 mb-0">
              <h2 className="name">
                {_.get(profile, 'attributes.first_name') || '--'}{' '}
                {_.get(profile, 'attributes.middle_name') || ''}{' '}
                {_.get(profile, 'attributes.last_name') || '--'}{' '}
              </h2>
              <small className="email">
                {_.get(profile, 'attributes.email') || '--'}
              </small>
            </div>
          </div>
          <div className="row">
            <div className="card-body p-3 mb-4">
              <div className="col-12 col-md-8">
                <div className="row">
                  <div className="col-md-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        First Name
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.first_name') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Middle Name
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.middle_name') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">Last Name</span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.last_name') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted"> No</span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.mobile_number') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Telephone No
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.telephone_number') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="detail-field">
                      <span className="detail-title text-muted">Email</span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.email') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="detail-field">
                      <span className="detail-title text-muted">Address</span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.address') || '--'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            {/* Temporarily hide this div */}
            <div className="my-5 col-12 d-none">
              <h1 className="">Help protect your account</h1>

              <div className="row align-items-center mt-4">
                <div className="col-1">
                  <div className="switch">
                    <input
                      type="checkbox"
                      checked={
                        `${_.get(profile, 'attributes.google2fa_enable')}` ===
                        '1'
                      }
                      onChange={
                        _.get(profile, 'attributes.google2fa_enable')
                          ? onDisabled2FA
                          : onGenerate2FA
                      }
                      className="form-control"
                    />
                    <span
                      className="slider round"
                      role="presentation"
                      onClick={
                        _.get(profile, 'attributes.google2fa_enable')
                          ? onDisabled2FA
                          : onGenerate2FA
                      }
                    />
                  </div>
                </div>
                <div className="col-11">
                  <p className="text-medium">
                    Enable Two-Factor authentication via Google Authenticator
                  </p>
                  <p className="text-small">
                    Use the Google Authenticator app to generate verification
                    codes for more protection
                  </p>
                </div>
              </div>
            </div>

            <div className="my-5 col-12">
              <h1 className="mb-3 font-weight-bold">
                Help protect your account
              </h1>

              <div className="d-flex" style={{ gap: 20 }}>
                <p>
                  [
                  <span role="img" aria-label="mobile phone">
                    📱 Mobile
                  </span>{' '}
                  -{' '}
                  <span className="font-weight-bold text-primary">
                    {_.get(profile, 'attributes.mobile_number')}
                  </span>
                  ]
                </p>
                <p>
                  [
                  <span role="img" aria-label="email">
                    📧 Email
                  </span>{' '}
                  -{' '}
                  <span className="font-weight-bold text-primary">
                    {_.get(profile, 'attributes.email')}
                  </span>
                  ]
                </p>
              </div>

              <p>
                <span role="img" aria-label="selected">
                  ✅
                </span>{' '}
                Currently selected:{' '}
                <span className="font-weight-bold text-primary">
                  {formattedSource}
                </span>
              </p>

              <button
                type="button"
                onClick={handleUpdateOtp}
                className="btn btn-dark text-white"
              >
                Use{' '}
                <span className="font-weight-bold">
                  {otpSource === 'EMAIL_OTP' ? ' Number' : 'Email'}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Profile.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  getProfile: PropTypes.instanceOf(Function).isRequired,
  generate2fa: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_PROFILE}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(Profile);
